define('BluePoint.SalesRepSection.SalesRepSection',
    [
        'BluePoint.SalesRepSection.SalesRepSection.View'
    ],
    function (
        SalesRepSectionView
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {

                var layout = container.getComponent('Layout');
                var customer = container.getComponent('UserProfile');

                if (layout && customer) {

                    // Async profile fetch
                    customer.getUserProfile().then(function (profile) {
                        console.log('Customer profile:', profile);

                        // var customerClassField = profile.customfields.find(function (field) {
                        //     return field.id === 'custentity3';
                        // });
                        // var customerClass = customerClassField ? customerClassField.value : null;
                        // console.log('Customer Category:', customerClass);

                        var salesRepInfoField = profile.customfields.find(function (field) {
                            return field.id === 'custentity407';
                        });
                        var salesRepInfo = salesRepInfoField ? salesRepInfoField.value : false;

                        console.log('Customer salesRepInfo:', salesRepInfo);

                        layout.addChildView('Header.SalesRepSection', function () {
                            return new SalesRepSectionView({
                                container: container,
                                salesRepInfo: salesRepInfo
                            });
                        });
                    });
                }
            }
        };
    });
